import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import classes from "./AttachmentList.scss";
import CreateDropDown from "../CreateDropDown";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import AttachmentItem from "../AttachmentItem";
import AttachmentItemV2 from "../AttachmentItemV2";
import AttachmentCard from "../AttachmentCard";
import AttachmentCardV2 from "../AttachmentCardV2";
import AttachmentItemV3 from "../AttachmentItemV3";
import MediaCardWrapper from "../MediaCardWrapper/MediaCardWrapper";
import AttachmentActionsModal from "../AttachmentActionsModal";
import { setLtiAttachmentDeleted } from "UnitPlans/components/Assessments/modules/AssessmentModule/AssessmentActions";
import {
  removeProgressElement,
  createAttachmentGroups,
  deleteAttachmentGroups,
  createAttachment,
  deleteAttachment,
  convertPDFToWorkbook,
  reorderAttachmentGroups,
} from "modules/Services";
import {
  getAttachmentCardTypeForAttachmentList,
  moveElementInArray,
  onEnterOrSpaceKeyDown,
} from "Utils";
import { Badge, Button } from "@toddle-edu/ds-web";
import {
  updateAttachment,
  updateOrganizationResource,
} from "OrganizationResources/modules/OrganizationResourcesModule";
import { writeAttachmentSimilarityReportInCache } from "modules/CommonGraphqlHelpers";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import { ModelContent } from "Attachment/AttachmentItem/AttachmentItem";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { retryAssignmentStudentTemplate } from "ClassRoom/modules/ClassRoomModule";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { ATTACHMENT_OMIT_ATTRIBUTES } from "store/static";

const renderAttachmentItemV2ClubbingCard = ({
  attachment,
  mode,
  horizontalCardStyle,
  showInlineAudioPlayer,
  showClubbedCard,
  loadMoreResources,
  lengthOfClubbedAttachment,
  t,
  deleteAttachment,
  isPrintEnabled,
  testId,
}) => {
  return (
    <React.Fragment key={attachment.id}>
      <AttachmentItemV2
        key={attachment.id}
        attachment={attachment}
        mode={mode}
        showThumb={true}
        horizontalCardStyle={horizontalCardStyle}
        showInlineAudioPlayer={showInlineAudioPlayer}
        deleteAttachment={deleteAttachment}
        isPrintEnabled={isPrintEnabled}
        testId={`${testId}-${attachment.id}`}
      />
      {!showClubbedCard && (
        <div onClick={loadMoreResources} className={classes.seeMoreBtn}>
          {t("common:see_more_count_between", {
            count: lengthOfClubbedAttachment,
          })}
        </div>
      )}
    </React.Fragment>
  );
};

const ClubbingCard = React.memo(props => {
  const {
    attachment,
    lengthOfClubbedAttachment,
    cardStyle,
    mode,
    showOverlayIcons,
    deleteAttachment,
    showClubbedCard,
    onClickClubCard,
    loadMoreResources,
    itemStyles,
    cardType,
    horizontalCardStyle,
    showSingleCardTheme,
    showInlineAudioPlayer,
    t,
    renameAttachment,
    updateAttachmentLockState,
    isPrintEnabled,
    testId,
    alwaysShowActions,
  } = props;

  if (showInlineAudioPlayer) {
    return renderAttachmentItemV2ClubbingCard({
      attachment,
      mode,
      horizontalCardStyle,
      showInlineAudioPlayer,
      showClubbedCard,
      loadMoreResources,
      lengthOfClubbedAttachment,
      t,
      isPrintEnabled,
      testId,
    });
  }
  switch (cardType) {
    case "verticalHorizontal":
      return (
        <AttachmentCardV2
          cardStyle={cardStyle}
          key={attachment.id}
          attachment={attachment}
          deleteAttachment={deleteAttachment}
          mode={mode}
          showOverlayIcons={showOverlayIcons}
          onClickMedia={onClickClubCard}
          clubingPlusCard={!showClubbedCard}
          lengthOfClubbedAttachment={lengthOfClubbedAttachment}
          itemStyles={itemStyles}
          cardType={cardType}
          showSingleCardTheme={showSingleCardTheme}
          testId={`${testId}-card-${attachment?.id}`}
        />
      );

    case "vertical":
      return (
        <AttachmentCard
          cardStyle={cardStyle}
          key={attachment.id}
          attachment={attachment}
          deleteAttachment={deleteAttachment}
          mode={mode}
          showOverlayIcons={showOverlayIcons}
          onClickMedia={onClickClubCard}
          clubingPlusCard={!showClubbedCard}
          lengthOfClubbedAttachment={lengthOfClubbedAttachment}
          itemStyles={itemStyles}
          testId={`${testId}-card-${attachment?.id}`}
        />
      );

    case "horizontalV2":
      return renderAttachmentItemV2ClubbingCard({
        attachment,
        mode,
        horizontalCardStyle,
        showInlineAudioPlayer,
        showClubbedCard,
        loadMoreResources,
        lengthOfClubbedAttachment,
        t,
        deleteAttachment,
        isPrintEnabled,
        testId,
      });

    case "design-media-card": {
      const {
        mediaCardSize,
        activeAttachment,
        attachmentMode,
        assessmentMode,
        onClickAttachmentCardLocal,
        attachmentBottomComponent,
        progressOfUploads,
        isLockingEnabled,
        getViewModeExtraButtons,
        sourceType,
        updateAttachments,
        showActionsOnHover,
        showDeleteForSelfInViewMode,
        showRenameAttachmentOption,
        showActionButtons,
        portalType,
        showIconButton,
        showAttachmentAsPost,
        disableActions,
        showWaveformPlayer,
        provider,
        isDragAndDropEnabled,
        snapshot,
        iconContainerStyle,
        dsVersion,
        showAttachmentInfo,
        getExtraDropdownOptions,
        isCustomClassForAudioWaveform,
        getPopupContainer,
        isDownloadEnabled,
      } = props;

      return (
        <>
          <MediaCardWrapper
            mediaCardSize={mediaCardSize}
            activeAttachment={activeAttachment}
            deleteAttachment={deleteAttachment}
            renameAttachment={renameAttachment}
            updateAttachmentLockState={updateAttachmentLockState}
            mode={attachmentMode}
            assessmentMode={assessmentMode}
            key={attachment.id}
            attachment={attachment}
            onClickAttachmentCard={onClickAttachmentCardLocal}
            attachmentBottomComponent={() =>
              _.isFunction(attachmentBottomComponent) &&
              !_.get(progressOfUploads, `${attachment.id}`, null) &&
              attachmentBottomComponent({ attachment })
            }
            isLockingEnabled={isLockingEnabled}
            horizontalCardStyle={horizontalCardStyle}
            getViewModeExtraButtons={getViewModeExtraButtons}
            sourceType={sourceType}
            updateAttachments={updateAttachments}
            showActionsOnHover={showActionsOnHover}
            showDeleteForSelfInViewMode={showDeleteForSelfInViewMode}
            showRenameAttachmentOption={showRenameAttachmentOption}
            showActionButtons={showActionButtons}
            portalType={portalType}
            showIconButton={showIconButton}
            showAttachmentAsPost={showAttachmentAsPost}
            disableActions={disableActions}
            showWaveformPlayer={showWaveformPlayer}
            provider={provider}
            isDragAndDropEnabled={isDragAndDropEnabled}
            snapshot={snapshot}
            iconContainerStyle={iconContainerStyle}
            isPrintEnabled={isPrintEnabled}
            testId={`${testId}-card-${attachment?.id}`}
            dsVersion={dsVersion}
            alwaysShowActions={alwaysShowActions}
            showAttachmentInfo={showAttachmentInfo}
            getExtraDropdownOptions={getExtraDropdownOptions}
            isCustomClassForAudioWaveform={isCustomClassForAudioWaveform}
            getPopupContainer={getPopupContainer}
            isDownloadEnabled={isDownloadEnabled}
          />
          {!showClubbedCard ? (
            <Button
              onClick={onClickClubCard}
              size={"small"}
              _legacy_variant={"inline-progressive"}
              variant="progressive"
              type="inline"
            >
              {t("common:see_more_count_between", {
                count: lengthOfClubbedAttachment,
              })}
            </Button>
          ) : null}
        </>
      );
    }

    default:
      return null;
  }
});

ClubbingCard.displayName = "ClubbingCard";

class AttachmentList extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.displaySequenceCount = _.size(_.get(this.props, "value", []));
    this.state = {
      ...this.state,
      showClubbedCard: false,
      currentDialogAction: null,
      isLoading: false,
      showMediaModal: false,
      activeIndex: 0,
      submissionTemplateLoaderArrState: [],
      visible: false,
    };
    if (props.customRef) {
      props.customRef(this);
    }
    this.attachmentItemRef = React.createRef(null);
  }

  componentDidMount() {
    this.updateSubmissionTemplateLoaderArr(
      this.props.submissionTemplateLoaderArr
    );
  }

  componentDidUpdate(prevProps) {
    const { submissionTemplateLoaderArr } = this.props;

    if (
      !_.isEqual(
        submissionTemplateLoaderArr,
        prevProps.submissionTemplateLoaderArr
      )
    ) {
      this.updateSubmissionTemplateLoaderArr(submissionTemplateLoaderArr);
    }
  }

  updateSubmissionTemplateLoaderArr = submissionTemplateLoaderArr => {
    this.setState({
      submissionTemplateLoaderArrState: submissionTemplateLoaderArr,
    });
  };

  handleDragAndDrop = async params => {
    const { value, parentId, parentType, reorderAttachmentGroups } = this.props;
    const { destination, source } = params;
    const toIndex = _.get(destination, "index", null);
    const fromIndex = _.get(source, "index", null);

    if (_.isEmpty(destination)) {
      return;
    }
    if (
      destination?.droppableId === source?.droppableId &&
      toIndex === fromIndex
    ) {
      return;
    }

    let putAfterItemId = null;
    const id = value[fromIndex].id;

    if (toIndex > 0) {
      if (fromIndex < toIndex) {
        putAfterItemId = _.get(value, `${[toIndex]}.id`, null);
      } else {
        putAfterItemId = _.get(value, `${[toIndex - 1]}.id`, null);
      }
    } else if (toIndex == _.size(value) - 1) {
      putAfterItemId = _.get(value.last(), `id`, null);
    }

    const updatedValue = moveElementInArray({
      array: value,
      fromIndex,
      toIndex,
    });

    await reorderAttachmentGroups({
      inputVariables: { id, putAfterItemId },
      parentId,
      parentType,
      updatedValue,
    });
  };

  processAttachmentBeforeUpload = async attachment => {
    //check if pdf present in attachments

    if (
      _.get(attachment, "type", "") === "WORKBOOK" &&
      _.get(attachment, "mimeType", "") === "application/pdf"
    ) {
      try {
        //convert pdf -> workbook
        this.setState({ isLoading: true });
        const {
          url: newUrl,
          thumbUrl,
          numOfPages,
          isPdfTruncated = false,
        } = await this.props.convertPDFToWorkbook({
          url: attachment.url,
        });
        if (_.isEmpty(newUrl)) return {};

        return {
          type: "WORKBOOK",
          url: newUrl,
          name: "Workbook",
          metadata: {
            ...attachment.metadata,
            workbookUrl: newUrl,
            isWorkbookWithPageView: true,
            sourcePdfUrl: attachment.url,
            isPdfTruncated,
            oldUrls: [],
            oldWorkbookUrls: [],
            numOfPages: numOfPages,
          },
          thumbUrl,
        };
      } catch (e) {
        return {};
      }
    }
    return attachment;
  };

  addAttachment = async (newAttachments, uploadId) => {
    const {
      value,
      shouldCreateAttachmentGroup,
      shouldCallMutation,
      parentId,
      parentType,
      createAttachmentGroups,
      createAttachment,
      portalType,
      lockingState,
      name,
      onTurnitinAttachmentRename,
    } = this.props;
    const newAttachmentsArr = await Promise.all(
      _.map(newAttachments, this.processAttachmentBeforeUpload)
    );

    newAttachments = _.filter(
      newAttachmentsArr,
      attachment => !_.isEmpty(attachment)
    );

    if (_.isEmpty(newAttachments)) {
      if (this.state.isLoading) this.setState({ isLoading: false });
      return;
    }

    const newName = _.get(newAttachmentsArr, "[0].name", "");
    const attachmentMetadata = _.get(newAttachmentsArr, "[0].metadata", {});

    //TODO : this is to stop calling mutation if attachment is of type QUESTION. this will change in further version.
    const isAttachmentTypeQuestion = _.some(
      newAttachmentsArr,
      attachment => attachment?.type === "QUESTION"
    );

    if (shouldCallMutation && !isAttachmentTypeQuestion) {
      if (shouldCreateAttachmentGroup) {
        this.setState({ isLoading: true });
        const inputVariables = {
          parentId,
          parentType,
          attachments: _.map(newAttachments, attachment => {
            return _.omit(attachment, ATTACHMENT_OMIT_ATTRIBUTES);
          }),
        };
        if (name === "studentTemplate") {
          this.displaySequenceCount += 1;
          inputVariables.displaySequence = this.displaySequenceCount;
        }
        newAttachments = await createAttachmentGroups({
          input: inputVariables,
          portalType,
        });
        this.setState({ isLoading: false });
      } else {
        newAttachments = await Promise.all(
          _.map(newAttachments, attachment => {
            return createAttachment({
              attachment,
              nodeId: parentId,
              parentType,
              type: parentType,
              lockingState,
            });
          })
        );
        newAttachments = _.reduce(
          newAttachments,
          (result, attachments) => {
            if (!_.isEmpty(attachments)) result.push(_.last(attachments));
            return result;
          },
          []
        );
      }
    } else {
      if (isAttachmentTypeQuestion) {
        //in type QUESTION all attachments will have ids from db
        //in this case create single attachment group and add multiple attachments in that

        newAttachments = [
          {
            id: uploadId,
            attachments: newAttachments,
            isPost: true,
          },
        ];
      } else {
        newAttachments = _.map(newAttachments, attachment => {
          if (shouldCreateAttachmentGroup) {
            return {
              id: uploadId,
              attachments: [{ ...attachment, id: uploadId }],
              isPost: true,
            };
          } else {
            return { ...attachment, id: uploadId };
          }
        });
      }
    }

    const isLTITool = _.get(attachmentMetadata, "type") === "LTI_TOOL";

    if (
      name === "studentTemplate" &&
      _.isFunction(onTurnitinAttachmentRename) &&
      isLTITool
    ) {
      const firstAttachmentGroup = _.first(newAttachments);
      const firstAttachment = shouldCreateAttachmentGroup
        ? _.get(firstAttachmentGroup, "attachments[0]")
        : firstAttachmentGroup;

      const attachmentId =
        _.get(firstAttachment, "id") || _.get(firstAttachment, "attachmentId");

      await onTurnitinAttachmentRename({
        newName,
        attachmentId,
        value: [...value, ...newAttachments],
      });
    }

    this.updateValue([...value, ...newAttachments], { parentType, parentId });
    return newAttachments;
  };

  deleteAttachment = async (attachmentId, isForced = false) => {
    const {
      value,
      deleteAttachmentGroups,
      deleteAttachment,
      parentId,
      parentType,
      shouldCallMutation,
      portalType,
      name,
      onDeleteAttachmentCallback,
      showDeleteModal,
      callDeleteCallbackOnConfirm,
      setLtiAttachmentDeleted,
    } = this.props;
    const attachment = _.find(value, { id: attachmentId });

    if (name === "studentTemplate" && isForced) {
      const isLtiAttachment = _.some(
        _.get(attachment, "attachments", []),
        att => {
          const type = _.get(att, "metadata.type");
          const service = _.get(att, "metadata.service");
          return type === "LTI_TOOL" || service === "TURNITIN";
        }
      );

      if (isLtiAttachment) {
        setLtiAttachmentDeleted(true);
      }
    }

    if (shouldCallMutation) {
      if (isForced) {
        if (_.get(attachment, "isPost", false) || name === "ltiTemplate") {
          this.setState({ isLoading: true });
          if (name === "studentTemplate") {
            this.displaySequenceCount -= 1;
          }
          await deleteAttachmentGroups({
            attachmentGroupIds: [attachmentId],
            parentId,
            parentType,
            portalType,
          });
          this.setState({ isLoading: false });
        } else {
          deleteAttachment({
            nodeId: parentId,
            attachmentId,
            type: parentType,
            portalType,
          });
        }
        this.updateValue(
          _.filter(value, attachment => attachment.id != attachmentId),
          { parentType, parentId }
        );
      } else {
        this.setState({ currentDialogAction: "DELETE" });
        this.currentDialgItem = attachment;
      }
    } else {
      this.updateValue(
        _.filter(value, attachment => attachment.id != attachmentId)
      );
    }

    if (
      _.isFunction(onDeleteAttachmentCallback) &&
      !callDeleteCallbackOnConfirm
    ) {
      if (showDeleteModal && !isForced) {
        this.setState({ currentDialogAction: "DELETE" });
        this.currentDialgItem = attachment;
      } else {
        onDeleteAttachmentCallback({ attachmentId, parentId, parentType });
      }
    }
  };

  renameAttachment = async attachment => {
    this.setState({ currentDialogAction: "RENAME" });
    this.currentDialgItem = attachment;
  };

  showAttachmentDetails = attachment => {
    this.setState({ currentDialogAction: "DETAILS" });
    this.currentDialgItem = attachment;
  };
  saveRenamedAttachment = async newName => {
    const {
      value,
      updateAttachment,
      updateOrganizationResource,
      parentType,
      shouldUpdateInputOnRename,
      portalType,
      renameAttachmentCallBack,
      name,
      onTurnitinAttachmentRename,
    } = this.props;

    const hasRenameAttachmentCallBack = _.isFunction(renameAttachmentCallBack);
    const attachmentId = _.get(this.currentDialgItem, "id", "");
    if (
      name === "studentTemplate" &&
      _.isFunction(onTurnitinAttachmentRename)
    ) {
      await onTurnitinAttachmentRename({
        newName,
        attachmentId,
        value,
      });
    }
    //TODO: this will be removed soon
    if (shouldUpdateInputOnRename) {
      this.updateValue(
        _.map(value, attachment =>
          attachment.id != attachmentId
            ? attachment
            : { ...attachment, name: newName }
        )
      );
    }

    if (!hasRenameAttachmentCallBack) {
      await updateAttachment({
        name: newName,
        id: attachmentId,
        portalType,
      });
    }

    // for organization resources update label in organization_resources table too
    // so that it will reflect across the platform
    if (parentType === "ORG_RESOURCES") {
      const attachments = _.get(this.props, "value", []);
      const attachmentToUpdate = _.find(attachments, attachment => {
        return _.get(attachment, "attachmentId") === attachmentId;
      });

      const attachmentParentType = _.get(attachmentToUpdate, "parentType");
      const resourceId = _.get(attachmentToUpdate, "resourceId");

      if (resourceId && attachmentParentType == "ORGANIZATION_RESOURCE") {
        await updateOrganizationResource({
          id: resourceId,
          label: newName,
          portalType,
        });
      }
    }

    if (hasRenameAttachmentCallBack) {
      renameAttachmentCallBack({ attachmentId, newName });
    }
  };

  updateAttachmentLockState = async ({ attachment, lockingState }) => {
    const { updateAttachment, portalType } = this.props;

    const updatedAttachment = {
      ...attachment,
      id: attachment?.attachmentId || attachment?.id,
      lockingState: {
        ...lockingState,
        __typename: "EntityLockingState",
      },
    };

    const updatedAttachmentObj = _.omit(updatedAttachment, ["attachmentId"]);

    writeAttachmentSimilarityReportInCache({
      attachmentId: attachment?.attachmentId || attachment?.id,
      data: updatedAttachmentObj,
    });

    await updateAttachment({
      id: attachment?.attachmentId || attachment?.id,
      lockingState,
      portalType,
    });
  };

  stopAllUploads = () => {
    const { uploadingResources, removeProgressElement } = this.props;
    _.forEach(uploadingResources, resource => {
      if (resource.cancelToken) {
        resource.cancelToken();
      }

      removeProgressElement({ id: resource.id });
    });
  };

  updateSelectedItems = ({ attachment, isSelected }) => {
    const { selectedItemType, updateSelectedItems, selectedItems } = this.props;
    let updatedSelectedItems = [];
    if (isSelected) {
      updatedSelectedItems = _.filter(selectedItems, item => {
        if (selectedItemType == "OBJECT") {
          return item.id != attachment.id;
        } else {
          return item == attachment.id;
        }
      });
    } else {
      if (selectedItemType == "OBJECT") {
        updatedSelectedItems = [...selectedItems, attachment];
      } else {
        updatedSelectedItems = [...selectedItems, attachment.id];
      }
    }
    updatedSelectedItems;
    updateSelectedItems(updatedSelectedItems);
  };

  getAttachmentsArray = attachments => {
    const sourceAttachments = [];
    _.forEach(attachments, attachment => {
      if (_.get(attachment, "isPost", false)) {
        // cloning attachments array to prevent modification in original array.
        const innerAttachments = [
          ...(!_.isNil(_.get(attachment, "attachments", []))
            ? _.get(attachment, "attachments", [])
            : []),
        ];
        _.forEach(innerAttachments, innerAttachment => {
          if (_.get(innerAttachment, "type") == "QUESTION")
            innerAttachment.questionAttachmentId = attachment.id;
        });
        sourceAttachments.push(...innerAttachments);
      } else sourceAttachments.push(attachment);
    });
    return sourceAttachments;
  };

  setTheatreModeAttachmentsWithIndex = ({
    selectedAttachment = null,
    attachmentId = null,
  }) => {
    const { value } = this.props;
    const sourceAttachments = this.getAttachmentsArray(value);
    if (
      !_.isNil(selectedAttachment) &&
      _.get(selectedAttachment, "isPost", false) &&
      _.isFunction(this.props.onClickMedia)
    ) {
      this.props.onClickMedia?.(selectedAttachment);
      return;
    }
    let currentAttachment = !_.isNil(selectedAttachment)
      ? _.cloneDeep(selectedAttachment)
      : !_.isNil(attachmentId)
      ? _.find(
          sourceAttachments,
          attachment =>
            _.get(attachment, "id") == attachmentId ||
            _.get(attachment, "attachmentId") == attachmentId
        )
      : null;

    if (_.get(selectedAttachment, "isPost", false)) {
      if (_.has(selectedAttachment, "attachments"))
        currentAttachment = _.cloneDeep(
          _.get(selectedAttachment, ["attachments", 0])
        );
    }
    const activeIndex = Math.max(
      _.findIndex(
        sourceAttachments,
        attachment =>
          _.get(attachment, "id") == _.get(currentAttachment, "id") ||
          _.get(attachment, "id") == _.get(currentAttachment, "attachmentId") || // when isPost is true, actual id is in attachmentId
          (!_.isNil(currentAttachment?.url) &&
            !_.isNil(attachment?.url) &&
            _.get(attachment, "url") == _.get(currentAttachment, "url")) ||
          (_.get(currentAttachment, "type") == "QUESTION" &&
            _.get(attachment, "type", "QUESTION") &&
            (_.get(currentAttachment, "id", null) ==
              _.get(attachment, "questionAttachmentId") ||
              _.get(currentAttachment, "questionAttachmentId", null) ==
                _.get(attachment, "questionAttachmentId")))
      ),
      0
    );

    // if clicked attachment is uploading, then don't open it
    if (
      _.includes(attachmentId, "NEW_") ||
      _.includes(_.get(selectedAttachment, ["id"]), "NEW_") ||
      _.includes(_.get(sourceAttachments, [activeIndex, "id"]), "NEW_")
    )
      return;

    this.setState({
      showMediaModal: true,
      activeIndex: activeIndex,
    });
    const { isToddleLibrary, unSubscribeToddleLibraryEvents } = this.props;
    if (isToddleLibrary) {
      unSubscribeToddleLibraryEvents();
    }
  };

  setTheatreModeAttachmentsWithIndexWrapper = attachment => {
    this.setTheatreModeAttachmentsWithIndex({
      selectedAttachment: attachment,
    });
  };

  onClickMediaLocal = () => {
    if (_.isFunction(this.props.onClickMedia)) {
      return this.props.onClickMedia;
    } else if (showNewTheatreMode() && _.get(this.props, "mode") != "select") {
      return this.setTheatreModeAttachmentsWithIndexWrapper;
    }
    return undefined;
  };

  getMatchingAttachmentViewHandler = cardType => {
    switch (cardType) {
      case "design-media-card":
        return (attachment, attachmentGroup) =>
          this.setTheatreModeAttachmentsWithIndex({
            selectedAttachment: attachment,
          });

      case "horizontal":
        return (attachmentId, attachment) =>
          this.setTheatreModeAttachmentsWithIndex({
            attachmentId,
            selectedAttachment: attachment,
          });

      case "horizontalV2":
        return (attachmentId, attachmentGroup, attachment) =>
          this.setTheatreModeAttachmentsWithIndex({
            attachmentId,
            selectedAttachment: attachment,
          });

      case "horizontalV3":
        return (attachmentId, attachmentGroup, attachment) =>
          this.setTheatreModeAttachmentsWithIndex({
            selectedAttachment: attachment,
          });
    }
  };

  onAddAttachmentClick = () => {
    this.setState(prevState => ({ visible: !prevState.visible }));
  };

  handleKeyDown = event => {
    const { parentType } = this.props;
    const shouldHandleEnterOrSpaceKeyDown = _.includes(
      ["TEACHER_NOTE"],
      parentType
    );

    if (shouldHandleEnterOrSpaceKeyDown) {
      return onEnterOrSpaceKeyDown(event, this.onAddAttachmentClick);
    }
  };

  renderList = () => {
    const {
      value,
      setToastMsg,
      updateLoadingState,
      exportAsPdf,
      parentId,
      parentType,
      uploadingResources,
      accept,
      mode,
      cardType,
      showCreateDropdown,
      containerStyle,
      createDropDownContainerStyle,
      attachmentContainerStyle,
      showOverlayIcons,
      onClickMedia,
      cardStyle,
      attachmentResponseObject,
      selectedItems,
      selectedItemType,
      dropDownOptions,
      addMediaText,
      onDropDownOptionClick,
      showSingleCardTheme,
      clubbingCards: _clubbingCards,
      canAddMaximumAttachments,
      t,
      portalType,
      buttonDropDownContainerStyle,
      buttonParentStyle,
      buttonDropDownStyle,
      createDropdownComponent,
      shouldCreateAsMedia,
      mediaCreationOptions,
      iconContainerStyle,
      onToggleMedia,
      itemStyles,
      onClickAttachmentCard,
      onClickCreatePost,
      activeAttachment,
      horizontalCardStyle,
      addAttachmentOptions,
      onLinkTypeClick,
      sourceType,
      showCreatePostButton,
      toolTipText,
      isDisabledModeObj,
      showOpenLinkInNewTabIcon,
      deleteMsgLabel = "common:media",
      isRightPaneChat,
      shouldCallMutation,
      onDeleteAudioAttachment,
      updateAttachments,
      createDropdownWrapperStyle,
      addButtonStyles,
      imageContainerStyle,
      attachmentBottomComponent,
      progressOfUploads,
      horizontalCardInnerClass,
      disableActions,
      mediaCardSize,
      addMediaTextLocale,
      showDeleteForSelfInViewMode,
      getViewModeExtraButtons,
      isShowIconsInBar,
      showV2Icons,
      customDropZoneStyle,
      showLocalAttachmentsInViewMode,
      createDropDownButtonComponent,
      attachmentExportOptions,
      defaultExportType,
      multiselect,
      disabled = false,
      createButtonComponentConfig = {},
      disableCreateDropdown,
      deleteEntityLabel,
      showNotificationsDot = false,
      showActionsOnHover,
      testId,
      assessmentMode,
      dropDownOptionButton, //props(function) to display custom button for dropdown- isShowIconsInBar should be true
      maxSize,
      showDeleteButtonForNewUploads,
      showActionButtons,
      deleteButtonText,
      cancelButtonText,
      showRenameAttachmentOption,
      isLockingEnabled,
      iconStyles,
      showIconButton,
      isNewDropdown,
      destroyPopupOnHide,
      showAttachmentAsPost,
      showWaveformPlayer,
      sourceFrom,
      dropdownIconButtonSize,
      isDragAndDropEnabled,
      mediaCardClasses,
      isToddleLibrary,
      subscribeToddleLibraryEvents,
      unSubscribeToddleLibraryEvents,
      isPrintEnabled,
      totalAttachmentsCount,
      dsVersion,
      retryAssignmentStudentTemplate,
      submissionTemplateAlertArr,
      assignmentCourseId,
      assessmentId,
      selectedCourseId,
      isLTIAttachmentPresent,
      enableShareModal,
      showUploadingResources,
      alwaysShowActions,
      showAttachmentInfo,
      renderCreateDropdown,
      showAddToPortfolio,
      getExtraDropdownOptions,
      isCustomClassForAudioWaveform,
      isTempAttachmentDeleteDisabled,
      isSinglePageAndNewUnitView,
      reflectionResponseCreatedBy,
      showAttachmentExtraIconButtons,
      getAttachmentExtraIconButtons,
      showNewTabOption,
      getPopupContainer,
      iconButtonType,
      iconButtonVariantV2,
      iconButtonStyles,
      courseId,
      unitCourseId,
      callDeleteCallbackOnConfirm,
      onDeleteAttachmentCallback,
      isDownloadEnabled,
      curriculumProgram,
      showAudioCurrentTime,
    } = this.props;

    const {
      showClubbedCard,
      currentDialogAction,
      isLoading,
      showMediaModal,
      activeIndex,
      submissionTemplateLoaderArrState,
    } = this.state;

    const conStyle = { paddingBottom: showClubbedCard ? "32px" : 0 };

    const keyToUniqBy = _.first(value)?.attachmentId ? "attachmentId" : "id";

    const attachments = _.uniqBy(
      [
        ...(value ? value : []),
        ...(showUploadingResources ? uploadingResources : []),
      ],
      keyToUniqBy
    );

    const currentAttachmentsLength = _.get(attachments, "length", 0);

    const lengthOfAttachments =
      totalAttachmentsCount || currentAttachmentsLength;

    const clubbingCards = _.min([_clubbingCards, currentAttachmentsLength]);

    const isClubbing = clubbingCards && lengthOfAttachments > clubbingCards;

    const lengthOfClubbedAttachment = lengthOfAttachments - clubbingCards;

    const onClickClubCard = () => {
      if (showClubbedCard) {
        this.onClickMediaLocal();
      } else {
        this.setState({ showClubbedCard: true });
      }
    };

    const deleteLabel = deleteEntityLabel
      ? deleteEntityLabel
      : t(deleteMsgLabel);

    const handleTryAgainClick = async attachmentId => {
      this.setState({
        submissionTemplateLoaderArrState: [
          ...submissionTemplateLoaderArrState,
          attachmentId,
        ],
      });
      await retryAssignmentStudentTemplate(submissionTemplateAlertArr);
      this.setState({
        submissionTemplateLoaderArrState: _.filter(
          submissionTemplateLoaderArrState,
          id => id === attachmentId
        ),
      });
    };

    return (
      <div
        className={classes.container}
        style={{
          ...containerStyle,
          ...conStyle,
          ...attachmentContainerStyle,
        }}
      >
        {_.map(attachments, (attachment, index) => {
          const isSelected =
            _.findIndex(selectedItems, item => {
              if (selectedItemType == "OBJECT") {
                return item.id == attachment.id;
              } else {
                return item == attachment.id;
              }
            }) >= 0;

          // this will not allow to delete if attachment id is not there
          let attachmentMode = mode;
          if (
            _.includes(attachment.id, "NEW_") &&
            showLocalAttachmentsInViewMode
          ) {
            attachmentMode = "view";
          }
          const showInlineAudioPlayer =
            isRightPaneChat && _.get(attachment, "type", "") === "AUDIO";

          let isDisabledMode = false;
          if (!_.isEmpty(isDisabledModeObj)) {
            isDisabledMode = _.get(isDisabledModeObj, attachment.id, false);
          }

          const attachmentCardTypeToRender = getAttachmentCardTypeForAttachmentList(
            {
              isClubbing,
              index,
              cardType,
              clubbingCards,
              showClubbedCard,
              showInlineAudioPlayer,
            }
          );

          const onClickAttachmentCardLocal = _.isFunction(
            this.props.onClickAttachmentCard
          )
            ? this.props.onClickAttachmentCard
            : showNewTheatreMode()
            ? _.get(this.props, "mode") == "select"
              ? undefined
              : this.getMatchingAttachmentViewHandler(
                  attachmentCardTypeToRender
                )
            : undefined;

          const isDeleteEnabled = isTempAttachmentDeleteDisabled
            ? !_.includes(attachment.id, "TEMP_") &&
              !_.includes(attachment.id, "NEW_")
            : true;

          const getAttachmentCardType = ({
            provider = {},
            snapshot = {},
          } = {}) => {
            switch (attachmentCardTypeToRender) {
              case "ClubbingCard":
                return (
                  <ClubbingCard
                    {...this.props}
                    key={attachment.id}
                    attachment={attachment}
                    lengthOfClubbedAttachment={lengthOfClubbedAttachment}
                    cardStyle={cardStyle}
                    mode={attachmentMode}
                    showOverlayIcons={showOverlayIcons}
                    deleteAttachment={this.deleteAttachment}
                    renameAttachment={this.renameAttachment}
                    updateAttachmentLockState={this.updateAttachmentLockState}
                    showClubbedCard={showClubbedCard}
                    onClickMedia={this.onClickMediaLocal()}
                    onClickClubCard={onClickClubCard}
                    itemStyles={itemStyles}
                    cardType={cardType}
                    showSingleCardTheme={showSingleCardTheme}
                    horizontalCardStyle={horizontalCardStyle}
                    t={t}
                    showInlineAudioPlayer={showInlineAudioPlayer}
                    attachmentMode={attachmentMode}
                    onClickAttachmentCardLocal={onClickAttachmentCardLocal}
                    provider={provider}
                    isDragAndDropEnabled={isDragAndDropEnabled}
                    snapshot={snapshot}
                  />
                );
              case "design-media-card": {
                return _.includes(
                  submissionTemplateLoaderArrState,
                  _.get(attachment, "attachments[0].id", "")
                ) ? (
                  <div className={classes.skeletonLoaderContainer}>
                    <SkeletonLoader width="40px" height="40px" />
                    <div className={classes.skeletonInnerContainer}>
                      <SkeletonLoader width="128px" height="12px" />
                      <SkeletonLoader width="64px" height="12px" />
                    </div>
                  </div>
                ) : (
                  <MediaCardWrapper
                    isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
                    className={mediaCardClasses}
                    mediaCardSize={mediaCardSize}
                    activeAttachment={activeAttachment}
                    deleteAttachment={this.deleteAttachment}
                    renameAttachment={this.renameAttachment}
                    showAttachmentDetails={this.showAttachmentDetails}
                    updateAttachmentLockState={this.updateAttachmentLockState}
                    mode={isDeleteEnabled ? attachmentMode : "view"}
                    assessmentMode={assessmentMode}
                    key={attachment.id}
                    attachment={attachment}
                    onClickAttachmentCard={onClickAttachmentCardLocal}
                    attachmentBottomComponent={() =>
                      _.isFunction(attachmentBottomComponent) &&
                      !_.get(progressOfUploads, `${attachment.id}`, null) &&
                      attachmentBottomComponent({ attachment })
                    }
                    isLockingEnabled={isLockingEnabled}
                    horizontalCardStyle={horizontalCardStyle}
                    getViewModeExtraButtons={getViewModeExtraButtons}
                    sourceType={sourceType}
                    updateAttachments={updateAttachments}
                    showActionsOnHover={showActionsOnHover}
                    showDeleteForSelfInViewMode={
                      isDeleteEnabled && showDeleteForSelfInViewMode
                    }
                    showRenameAttachmentOption={showRenameAttachmentOption}
                    showActionButtons={showActionButtons}
                    portalType={portalType}
                    showIconButton={showIconButton}
                    showAttachmentAsPost={showAttachmentAsPost}
                    disableActions={disableActions}
                    showWaveformPlayer={showWaveformPlayer}
                    dropdownIconButtonSize={dropdownIconButtonSize}
                    provider={provider}
                    isDragAndDropEnabled={isDragAndDropEnabled}
                    snapshot={snapshot}
                    iconContainerStyle={iconContainerStyle}
                    isPrintEnabled={isPrintEnabled}
                    courseId={
                      assignmentCourseId || selectedCourseId || courseId
                    }
                    assessmentId={assessmentId}
                    testId={`${testId}-card-${attachment?.id}`}
                    dsVersion={dsVersion}
                    submissionTemplateAlertArr={submissionTemplateAlertArr}
                    handleTryAgainClick={handleTryAgainClick}
                    isLTIAttachmentPresent={isLTIAttachmentPresent}
                    alwaysShowActions={alwaysShowActions}
                    showAttachmentInfo={showAttachmentInfo}
                    showAddToPortfolio={showAddToPortfolio}
                    getExtraDropdownOptions={getExtraDropdownOptions}
                    isCustomClassForAudioWaveform={
                      isCustomClassForAudioWaveform
                    }
                    reflectionResponseCreatedBy={reflectionResponseCreatedBy}
                    showAttachmentExtraIconButtons={
                      showAttachmentExtraIconButtons
                    }
                    getAttachmentExtraIconButtons={
                      getAttachmentExtraIconButtons
                    }
                    showNewTabOption={showNewTabOption}
                    getPopupContainer={getPopupContainer}
                    unitCourseId={unitCourseId}
                    curriculumProgram={curriculumProgram}
                    parentType={parentType}
                    isDownloadEnabled={isDownloadEnabled}
                    showEditResponseButtonProps={
                      this.props.showEditResponseButtonProps
                    }
                    showAudioCurrentTime={showAudioCurrentTime}
                  />
                );
              }
              case "horizontalV2":
                return (
                  <AttachmentItemV2
                    // setting ref only for the active attachment
                    ref={
                      activeAttachment === attachment.id
                        ? this.attachmentItemRef
                        : null
                    }
                    key={attachment.id}
                    attachment={attachment}
                    mode={attachmentMode}
                    onClickAttachmentCard={onClickAttachmentCardLocal}
                    onClickCreatePost={onClickCreatePost}
                    activeAttachment={activeAttachment}
                    showCreatePostButton={showCreatePostButton}
                    showThumb={true}
                    showOpenLinkInNewTabIcon={showOpenLinkInNewTabIcon}
                    updateSelectedItems={this.updateSelectedItems}
                    deleteAttachment={this.deleteAttachment}
                    horizontalCardStyle={horizontalCardStyle}
                    showInlineAudioPlayer={showInlineAudioPlayer}
                    disableActions={disableActions}
                    attachmentBottomComponent={params =>
                      _.isFunction(attachmentBottomComponent) &&
                      !_.get(progressOfUploads, `${attachment.id}`, null) &&
                      attachmentBottomComponent({ ...params, attachment })
                    }
                    horizontalCardInnerClass={horizontalCardInnerClass}
                    attachmentResponseObject={attachmentResponseObject}
                    showDeleteForSelfInViewMode={showDeleteForSelfInViewMode}
                    parentId={parentId}
                    parentType={parentType}
                    isLastAttachment={index === lengthOfAttachments - 1}
                    isPrintEnabled={isPrintEnabled}
                    testId={`${testId}-attachmentItem-${attachment?.id}`}
                  />
                );
              case "horizontalV3":
                return (
                  <AttachmentItemV3
                    key={attachment.id}
                    attachment={attachment}
                    mode={attachmentMode}
                    onClickAttachmentCard={onClickAttachmentCardLocal}
                    horizontalCardStyle={horizontalCardStyle}
                    isDisabledMode={isDisabledMode}
                    showCreatePostButton={showCreatePostButton}
                    onClickCreatePost={onClickCreatePost}
                    showDeleteForSelfInViewMode={showDeleteForSelfInViewMode}
                    deleteAttachment={this.deleteAttachment}
                    attachmentBottomComponent={params =>
                      _.isFunction(attachmentBottomComponent) &&
                      attachmentBottomComponent({ ...params, attachment })
                    }
                    iconStyles={iconStyles}
                  />
                );
              case "verticalHorizontal":
                return (
                  <AttachmentCardV2
                    key={attachment.id}
                    attachment={attachment}
                    isSelected={isSelected}
                    cardStyle={cardStyle}
                    mode={attachmentMode}
                    showOverlayIcons={showOverlayIcons}
                    onClickMedia={this.onClickMediaLocal()}
                    showSingleCardTheme={showSingleCardTheme}
                    deleteAttachment={this.deleteAttachment}
                    updateSelectedItems={this.updateSelectedItems}
                    iconContainerStyle={iconContainerStyle}
                    itemStyles={itemStyles}
                    cardType={cardType}
                    toolTipText={toolTipText}
                    isDisabledMode={isDisabledMode}
                    attachmentResponseObject={attachmentResponseObject}
                    attachmentBottomComponent={
                      !_.get(progressOfUploads, `${attachment.id}`, null) &&
                      attachmentBottomComponent
                    }
                    horizontalCardInnerClass={horizontalCardInnerClass}
                    testId={`${testId}-card-${attachment?.id}`}
                  />
                );
              case "horizontal":
                return (
                  <AttachmentItem
                    isSelected={isSelected}
                    key={attachment.id}
                    attachment={attachment}
                    mode={attachmentMode}
                    onClickMedia={this.onClickMediaLocal()}
                    customContainerStyle={horizontalCardStyle}
                    updateSelectedItems={this.updateSelectedItems}
                    deleteAttachment={this.deleteAttachment}
                    onClickAttachmentCard={onClickAttachmentCardLocal}
                    sourceType={sourceType}
                    onDeleteAudioAttachment={onDeleteAudioAttachment}
                    updateAttachments={updateAttachments}
                    imageContainerStyle={imageContainerStyle}
                    disabled={disabled}
                    showDeleteButtonForNewUploads={
                      showDeleteButtonForNewUploads
                    }
                    showAudioDownloadButton={_.get(
                      this.props,
                      "showAudioDownloadButton",
                      true
                    )}
                    showWaveformPlayer={showWaveformPlayer}
                  />
                );
              case "vertical":
                return (
                  <AttachmentCard
                    cardStyle={cardStyle}
                    key={attachment.id}
                    attachment={attachment}
                    deleteAttachment={this.deleteAttachment}
                    mode={attachmentMode}
                    showOverlayIcons={showOverlayIcons}
                    onClickMedia={this.onClickMediaLocal()}
                    iconContainerStyle={iconContainerStyle}
                    onToggleMedia={onToggleMedia}
                    itemStyles={itemStyles}
                    onLinkTypeClick={onLinkTypeClick}
                    isDisabledMode={isDisabledMode}
                    toolTipText={toolTipText}
                    attachmentResponseObject={attachmentResponseObject}
                    testId={`${testId}-card-${attachment?.id}`}
                  />
                );
            }
          };

          const showNotificationsBadge = () => {
            switch (sourceFrom) {
              case "PROJECTS":
                return (
                  (!_.isNil(attachment?.isRead) && !attachment?.isRead) ||
                  (!_.isNil(attachment?.isAnnotationRead) &&
                    !attachment?.isAnnotationRead)
                );

              default:
                //isNil is used to ensure that notification is not shown on the card in case of null or undefined values. Only for false boolean we will show the notifications.
                return !_.isNil(attachment?.isRead) && !attachment?.isRead;
            }
          };

          const renderAttachmentCard = ({
            provider = {},
            snapshot = {},
          } = {}) => {
            if (showNotificationsDot && showNotificationsBadge()) {
              return (
                <Badge type="dot">
                  <div>{getAttachmentCardType({ provider })}</div>
                </Badge>
              );
            } else {
              return getAttachmentCardType({ provider, snapshot });
            }
          };

          if (
            isDragAndDropEnabled &&
            attachmentCardTypeToRender !== "null" &&
            _.isEmpty(submissionTemplateLoaderArrState)
          ) {
            return (
              <Draggable
                key={attachment?.id}
                draggableId={attachment?.id}
                index={index}
              >
                {(provider, snapshot) =>
                  renderAttachmentCard({ provider, snapshot })
                }
              </Draggable>
            );
          } else {
            return renderAttachmentCard();
          }
        })}

        {!!showCreateDropdown &&
          mode == "edit" &&
          !disabled &&
          (!canAddMaximumAttachments ||
            canAddMaximumAttachments > lengthOfAttachments) &&
          (createDropdownComponent ? (
            createDropdownComponent
          ) : renderCreateDropdown ? (
            <div
              className={classes.createContainer}
              style={createDropdownWrapperStyle}
              tabIndex={0}
              onKeyDown={this.handleKeyDown}
              data-test-id={`${testId}-addAttachmentCardButton`}
            >
              <CreateDropDown
                attachments={value}
                mediaCreationOptions={mediaCreationOptions}
                shouldCreateAsMedia={shouldCreateAsMedia}
                exportAsPdf={exportAsPdf}
                addAttachment={this.addAttachment}
                updateLoadingState={updateLoadingState}
                setToastMsg={setToastMsg}
                parentId={parentId}
                parentType={parentType}
                accept={accept}
                buttonDropDownContainerStyle={{
                  top: cardType == "horizontal" ? 72 : 154,
                  ...buttonDropDownContainerStyle,
                }}
                buttonParentStyle={buttonParentStyle}
                buttonDropDownStyle={buttonDropDownStyle}
                addMediaText={
                  addMediaTextLocale ? t(addMediaTextLocale) : addMediaText
                }
                cardType={cardType}
                containerStyle={{
                  height: cardType == "horizontal" ? 71 : 154,
                  borderRadius: cardType == "horizontal" ? 8 : 2,
                  ...createDropDownContainerStyle,
                }}
                dropDownOptions={dropDownOptions}
                onDropDownOptionClick={onDropDownOptionClick}
                portalType={portalType}
                addAttachmentOptions={addAttachmentOptions}
                sourceType={sourceType}
                shouldCallMutation={shouldCallMutation}
                updateAttachments={updateAttachments}
                addButtonStyles={addButtonStyles}
                isShowIconsInBar={isShowIconsInBar}
                showV2Icons={showV2Icons}
                customDropZoneStyle={customDropZoneStyle}
                buttonComponent={createDropDownButtonComponent}
                defaultExportType={defaultExportType}
                attachmentExportOptions={attachmentExportOptions}
                multiselect={multiselect}
                createButtonComponentConfig={createButtonComponentConfig}
                disabled={disableCreateDropdown}
                dropDownOptionButton={dropDownOptionButton}
                maxSize={maxSize}
                testId={testId}
                isNewDropdown={isNewDropdown}
                destroyPopupOnHide={destroyPopupOnHide}
                visible={this.state.visible}
                dsVersion={dsVersion}
                enableShareModal={enableShareModal}
                iconButtonType={iconButtonType}
                iconButtonVariantV2={iconButtonVariantV2}
                iconButtonStyles={iconButtonStyles}
              />
            </div>
          ) : null)}
        {showClubbedCard && (
          <div
            className={classes.seeLessBtn}
            onClick={() => this.setState({ showClubbedCard: false })}
          >{`See Less`}</div>
        )}

        {!!currentDialogAction && (
          <AttachmentActionsModal
            onClose={() => this.setState({ currentDialogAction: null })}
            t={t}
            deleteLabel={deleteLabel}
            deleteButtonText={deleteButtonText}
            cancelButtonText={cancelButtonText}
            currentDialogAction={currentDialogAction}
            currentDialgItem={this.currentDialgItem}
            deleteAttachment={this.deleteAttachment}
            saveRenamedAttachment={this.saveRenamedAttachment}
            dsVersion={dsVersion}
            testId={testId}
            callDeleteCallbackOnConfirm={callDeleteCallbackOnConfirm}
            onDeleteAttachmentCallback={onDeleteAttachmentCallback}
            parentId={parentId}
            parentType={parentType}
          />
        )}
        {isLoading && <FullScreenLoader />}
        {showMediaModal ? (
          <ModelContent
            canDownloadMedia={isPrintEnabled}
            attachments={this.getAttachmentsArray(attachments)}
            activeIndex={
              showNewTheatreMode() ? _.get(this.state, "activeIndex", 0) : 0
            }
            toggleMediaModal={value => {
              this.setState({ showMediaModal: value });
              this.props?.toggleMediaModalProps?.(value);
              if (isToddleLibrary) {
                if (value) unSubscribeToddleLibraryEvents();
                else {
                  _.delay(subscribeToddleLibraryEvents, 500);
                }
              }
            }}
            mode={mode}
            sourceType={sourceType}
            updateAttachments={updateAttachments}
            onWorkbookUpdateSuccessfully={() =>
              this.setState({ showMediaModal: value })
            }
            portalType={portalType}
            testId={testId}
            showEditResponseButtonProps={this.props.showEditResponseButtonProps}
            onEditAttachmentClick={this.props.onEditAttachmentClick}
            showPdfTronEditButton={this.props.showPdfTronEditButton}
            allowedPermissions={this.props.allowedPermissions}
          />
        ) : null}
      </div>
    );
  };

  renderEdit = () => {
    const { isDragAndDropEnabled, name, customHandleDragAndDrop } = this.props;
    if (
      isDragAndDropEnabled &&
      _.isEmpty(this.state.submissionTemplateLoaderArrState)
    ) {
      return (
        <DragDropContext
          onDragEnd={
            customHandleDragAndDrop
              ? customHandleDragAndDrop
              : this.handleDragAndDrop
          }
          disableInteractiveElementBlocking
        >
          <Droppable droppableId={name}>
            {provided => {
              return (
                <div
                  className={classes.droppableListContainer}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {this.renderList()}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      );
    } else {
      return this.renderList();
    }
  };

  renderView = () => {
    return this.renderList();
  };
}

const getUploadingResources = ({ parentId, parentType, progressOfUploads }) => {
  const keys = Object.keys(progressOfUploads);
  const uploadingResources = [];
  _.forEach(keys, key => {
    const resource = progressOfUploads[key];

    if (
      resource.parentType == parentType &&
      resource.parentId == parentId &&
      resource.status !== "DOWNLOAD"
    ) {
      uploadingResources.push({
        id: resource.id,
        progress: resource.progress,
        cancelToken: resource.cancelToken,
        ..._.get(resource, "attachment", {}),
      });
    }
  });

  return uploadingResources;
};

const mapStateToProps = (state, ownProps) => {
  const progressOfUploads = state.app_services.progressOfUploads;
  const mode = _.get(ownProps, "disabled", false) ? "view" : ownProps?.mode;

  const uploadingResources = getUploadingResources({
    parentType: ownProps.parentType,
    parentId: ownProps.parentId,
    progressOfUploads,
  });

  const isDragAndDropEnabled =
    _.get(ownProps, "isDragAndDropEnabled", false) &&
    mode === "edit" &&
    _.isEmpty(uploadingResources); // do not allow drag and drop when attachments are uploading

  return {
    uploadingResources,
    progressOfUploads,
    mode,
    isDragAndDropEnabled,
  };
};

const mapActionCreators = {
  removeProgressElement,
  createAttachmentGroups,
  deleteAttachmentGroups,
  createAttachment,
  deleteAttachment,
  updateAttachment,
  convertPDFToWorkbook,
  updateOrganizationResource,
  reorderAttachmentGroups,
  retryAssignmentStudentTemplate,
  setLtiAttachmentDeleted,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators, null, { withRef: true })
)(AttachmentList);

AttachmentList.propTypes = {
  ...UIBaseComponent.propTypes,
  value: PropTypes.array,
  parentId: PropTypes.string,
  parentType: PropTypes.string,
  mode: PropTypes.oneOf(["view", "edit", "select"]),
  cardType: PropTypes.oneOf([
    "horizontal",
    "verticalHorizontal",
    "horizontalV2",
    "horizontalV3",
    "vertical",
    "ClubbingCard",
    "design-media-card",
  ]),
  showCreateDropdown: PropTypes.bool,
  onClickMedia: PropTypes.func,
  clubbingCards: PropTypes.number,
  showSingleCardTheme: PropTypes.bool,
  activeAttachment: PropTypes.string,
  showCreatePostButton: PropTypes.bool,
  showOpenLinkInNewTabIcon: PropTypes.bool,
  isRightPaneChat: PropTypes.bool,
  createDropdownContainerStyle: PropTypes.object,
  showDeleteForSelfInViewMode: PropTypes.bool,
  showLocalAttachmentsInViewMode: PropTypes.bool,
  showActionsOnHover: PropTypes.bool,
  disableCreateDropdown: PropTypes.bool,
  showDeleteButtonForNewUploads: PropTypes.bool,
  showRenameAttachmentOption: PropTypes.bool,
  isLockingEnabled: PropTypes.bool,
  showIconButton: PropTypes.bool,
  isNewDropdown: PropTypes.bool,
  shouldUpdateInputOnRename: PropTypes.bool,
  showWaveformPlayer: PropTypes.bool,
  isDragAndDropEnabled: PropTypes.bool,
  isPrintEnabled: PropTypes.bool,
  dsVersion: PropTypes.string,
  assignmentCourseId: PropTypes.string,
  assessmentId: PropTypes.string,
  selectedCourseId: PropTypes.string,
  courseId: PropTypes.string,
  unitCourseId: PropTypes.string,
  isCustomClassForAudioWaveform: PropTypes.bool,
  isTempAttachmentDeleteDisabled: PropTypes.bool,
  iconButtonType: PropTypes.string,
  iconButtonVariantV2: PropTypes.string,
  iconButtonStyles: PropTypes.object,
  showAudioCurrentTime: PropTypes.bool,
};

AttachmentList.defaultProps = {
  ...UIBaseComponent.defaultProps,
  isPrintEnabled: true,
  canAddMaximumAttachments: null,
  shouldCreateAttachmentGroup: false,
  shouldCallMutation: false,
  exportAsPdf: false,
  parentId: "",
  parentType: "",
  mode: "edit",
  cardType: "horizontal",
  selectedItemType: "ID",
  showCreateDropdown: true,
  disableCreateDropdown: false,
  emptyText: "",
  attachmentContainerStyle: {},
  containerStyle: {},
  createDropDownContainerStyle: {},
  showOverlayIcons: true,
  selectedItems: [],
  clubbingCards: 0,
  showSingleCardTheme: false,
  shouldCreateAsMedia: false,
  buttonDropDownContainerStyle: {},
  buttonDropDownStyle: {},
  activeAttachment: "",
  showCreatePostButton: false,
  showOpenLinkInNewTabIcon: false,
  isRightPaneChat: false,
  showDeleteForSelfInViewMode: false,
  showLocalAttachmentsInViewMode: true,
  showActionsOnHover: false,
  showDeleteButtonForNewUploads: false,
  showActionButtons: true,
  showRenameAttachmentOption: true,
  deleteButtonText: "common:delete_agree",
  cancelButtonText: "common:agree_cancel",
  isLockingEnabled: false,
  showIconButton: false,
  isNewDropdown: false,
  shouldUpdateInputOnRename: false,
  showWaveformPlayer: false,
  isDragAndDropEnabled: false,
  dsVersion: "1.0",
  showUploadingResources: true,
  renderCreateDropdown: true,
  showDeleteModal: false,
  isCustomClassForAudioWaveform: false,
  isTempAttachmentDeleteDisabled: false,
  callDeleteCallbackOnConfirm: false,
  showAudioCurrentTime: false,
};
